import styled from "styled-components";

export const StyledInnerContainer = styled.div`
    padding: 0.75rem;
`;

export const StyledList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const StyledListItem = styled.li`
    padding: 0.25rem;
    border-bottom: 1px solid var(--ds-color-silver);
`;

export const StyledItemButton = styled.button`
    appearance: none;
    border-radius: var(--ds-border-radius);
    background: var(--ds-color-white);
    width: 100%;
    border: none;
    padding: 0.5rem;
    font-size: 0.875rem;
    color: var(--ds-color-night);
    &:hover {
        background: var(--ds-color-blue-10);
    }
    &:focus {
        box-shadow: 0px 0px 0px 2px var(--ds-color-white),
            0px 0px 0px 4px var(--ds-color-blue-100);
    }
`;

export const StyledItemName = styled.span`
    color: var(--ds-color-night);
    text-align: left;
    display: block;
    word-break: break-all;
`;

export const StyledItemDate = styled.span`
    color: var(--ds-color-metal);
    white-space: nowrap;
    text-align: left;
    display: block;
`;

export const StyledEmptyMessage = styled.p`
    font-size: 0.875rem;
    padding-top: 4rem;
    text-align: center;
    max-width: 200px;
    margin: 0 auto;
`;
